(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-people]')];
    const select = (people) => {
      if (!tabs.some(tab => tab.dataset.people === people)) return;
      tabs.forEach(tab => { const active = tab.dataset.people === people; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== people; });
    };
    const fromHash = () => select(/^#p(4|6|8|10|12)$/.exec(location.hash)?.[1] || '4');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => { history.replaceState(null, '', '#p' + tab.dataset.people); select(tab.dataset.people); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); tabs[next].focus(); tabs[next].click(); }
      });
    });
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  const initAll = () => document.querySelectorAll('[data-pr-sets]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('click', event => {
    const link = event.target.closest('.pr-nav-sets a');
    if (!link || location.pathname !== '/pages/geschirrsets') return;
    const drawer = link.closest('mobile-navigation');
    drawer?.querySelector('[data-action="close"]')?.click();
  });
})();
